export class TradeStore {}
